import { Suspense, lazy, useMemo, useState, useCallback } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { Sidebar } from '../Sidebar'
import {
  Container,
  MainContent,
  SidebarContainer,
  SidebarSlot
} from './Layout.styles'
import {
  fetchConversationsHistory,
  fetchPromptTemplates,
  deleteConversation,
  fetchConversationMessages,
  sendMessage
} from '../../api/chat/chat'
import { useChatConfig, useLivingComplex } from '../../shared/hooks/api'
import { ChatDataSource } from '../../modules/chat/types/chat'

const ChatModule = lazy(() =>
  import('../../modules/chat').then(module => ({ default: module.ChatModule }))
)

const chatDataSource: ChatDataSource = {
  getPromptTemplates: fetchPromptTemplates,
  sendMessage,
  deleteConversation,
  getConversationsHistory: fetchConversationsHistory,
  getMessages: fetchConversationMessages
}

export const Layout = () => {
  const { livingComplexId } = useParams<{ livingComplexId: string }>()
  const { data: chatConfig, status: chatStatus } = useChatConfig()
  const { data: livingComplex } = useLivingComplex(livingComplexId ?? '')
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const toggleSidebar = useCallback(
    () => setSidebarCollapsed(prev => !prev),
    []
  )
  const extendedChatConfig = useMemo(
    () =>
      chatConfig
        ? {
            ...chatConfig,
            ...(livingComplex?.name
              ? { title: `Аналитика по ЖК ${livingComplex.name}` }
              : {})
          }
        : undefined,
    [chatConfig, livingComplex?.name]
  )
  const chatIsReady = chatStatus !== 'pending'

  return (
    <Container>
      <SidebarContainer>
        <SidebarSlot $collapsed={sidebarCollapsed}>
          <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
        </SidebarSlot>
        <MainContent>
          <Outlet />
        </MainContent>
      </SidebarContainer>
      {chatIsReady && (
        <Suspense fallback={null}>
          <ChatModule
            config={extendedChatConfig}
            dataSource={chatDataSource}
            projectId={livingComplexId ?? ''}
          />
        </Suspense>
      )}
    </Container>
  )
}
